var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrangeSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7878 33.0453H13.0739C5.18775 33.0453 1.81836 29.6759 1.81836 21.7898V13.0758C1.81836 5.1897 5.18775 1.82031 13.0739 1.82031H21.7878C29.6739 1.82031 33.0433 5.1897 33.0433 13.0758V21.7898C33.0433 29.6759 29.6739 33.0453 21.7878 33.0453ZM13.0739 3.9988C6.37866 3.9988 3.99684 6.38061 3.99684 13.0758V21.7898C3.99684 28.485 6.37866 30.8668 13.0739 30.8668H21.7878C28.483 30.8668 30.8648 28.485 30.8648 21.7898V13.0758C30.8648 6.38061 28.483 3.9988 21.7878 3.9988H13.0739Z",
    fill: "#40196D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4919 25.5743C20.2159 25.5743 19.94 25.4726 19.7221 25.2548C19.301 24.8336 19.301 24.1365 19.7221 23.7153L24.1372 19.3003C24.5584 18.8791 25.2555 18.8791 25.6767 19.3003C26.0978 19.7214 26.0978 20.4185 25.6767 20.8397L21.2616 25.2548C21.0583 25.4581 20.7823 25.5743 20.4919 25.5743Z",
    fill: "#40196D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9115 21.155H9.95252C9.35707 21.155 8.86328 20.6613 8.86328 20.0658C8.86328 19.4704 9.35707 18.9766 9.95252 18.9766H24.926C25.5214 18.9766 26.0152 19.4704 26.0152 20.0658C26.0152 20.6613 25.5214 21.155 24.9115 21.155Z",
    fill: "#40196D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9528 15.8712C9.67686 15.8712 9.40092 15.7695 9.18307 15.5517C8.76189 15.1305 8.76189 14.4334 9.18307 14.0122L13.5981 9.59713C14.0193 9.17596 14.7164 9.17596 15.1376 9.59713C15.5588 10.0183 15.5588 10.7154 15.1376 11.1366L10.7225 15.5517C10.5047 15.7695 10.2287 15.8712 9.9528 15.8712Z",
    fill: "#40196D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9115 15.8816H9.95252C9.35707 15.8816 8.86328 15.3878 8.86328 14.7924C8.86328 14.1969 9.35707 13.7031 9.95252 13.7031H24.926C25.5214 13.7031 26.0152 14.1969 26.0152 14.7924C26.0152 15.3878 25.5214 15.8816 24.9115 15.8816Z",
    fill: "#40196D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrangeSquare);
export default __webpack_public_path__ + "static/media/arrange-square.a9cdc47735f674d13e335add414df402.svg";
export { ForwardRef as ReactComponent };